// extracted by mini-css-extract-plugin
export default {"base":"base--LQ3Yk","top":"top--LQ3Yk","bottom":"bottom--LQ3Yk"};